import React, { Component } from 'react';
import Moment from 'react-moment';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';

import { ListItem, Button, Details } from './styles';
import spacer from '../../../../assets/images/spacer.png';

class Item extends Component {
  onPress = () => {
    this.props.onPressItem(this.props.id);
  };

  render() {
    const {
      date,
      transferInstrument,
      value,
      status,
    } = this.props.item;

    return (
      <div>
        <ListItem selected={this.props.selected}>
          <div className="row">
            <h2>Data</h2>
            <Moment className="date" format="DD/MM/YYYY">{date}</Moment>
          </div>
          <div className="row">
            <h2>Conta</h2>
            <p>{`${transferInstrument.accountNumber}-${transferInstrument.accountCheckNumber}`}</p>
          </div>
          <div className="row">
            <h2>Valor</h2>
            <p>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)}</p>
          </div>
          <div className="row last-row">
            <h2>Status</h2>
            {status === 'REQUESTED' && <p>Pendente</p>}
            {status === 'COMPLETED' && <p>Concluído</p>}
            {status === 'FAILED' && <p>Cancelado</p>}
          </div>
          <Button type="submit" onClick={this.onPress}>
            <span>Detalhes</span>
            {!this.props.selected && <FaAngleDown className="fa fa-angle-down" />}
            {this.props.selected && <FaAngleUp className="fa fa-angle-up" />}
          </Button>
        </ListItem>
        <Details selected={this.props.selected} status={status}>
          <img src={spacer} alt="" className="spacer" />
          <div className="container">
            <div className="row">
              <p>
                <span>Banco:</span>
                {transferInstrument.bankNumber}
              </p>
              <p>
                <span>Agência:</span>
                {`${transferInstrument.agencyNumber}${transferInstrument.agencyCheckNumber ? `-${transferInstrument.agencyCheckNumber}` : ''}`}
              </p>
              <p>
                <span>{`Conta ${transferInstrument.accountType === 'CHECKING' ? 'Corrente' : 'Poupança'}:`}</span>
                {`${transferInstrument.accountNumber}-${transferInstrument.accountCheckNumber}`}
              </p>
            </div>
            <div className="row">
              <p>
                <span className="status">Status:</span>
                <br />
                {status === 'REQUESTED' && 'Estamos processando o pagamento do repasse devido.'}
                {status === 'COMPLETED' && 'Pagamento do repasse devido concluído com sucesso. O dinheiro já se encontra na conta de destino.'}
                {status === 'FAILED' && 'Houve um problema ao efetuar o pagamento do repasse devido. Entre em contato com o nosso time de atendimento.'}
              </p>
            </div>
          </div>
        </Details>
      </div>
    );
  }
}

export default Item;
